module.exports = __webpack_public_path__ + "img/103.6.7fa2ab54.png";